/** Default copy for Gifting with Love & Dress Code cards (admin can override). */
export const INFO_CARDS_DEFAULTS = {
  gifting_card_title: 'Gifting with Love',
  gifting_card_body:
    'Your presence and blessings are the most cherished gifts we could receive.\n\nFor those who may wish to mark the occasion with a gift, gestures may be offered in monetary form to the contact below or thoughtfully presented in person during the ceremony.\n\nEvery expression of generosity is received with sincere appreciation.',
  gifting_card_contact: '+254727768617 (Ursula Mugabe)',
  dress_code_card_title: 'Dress Code',
  dress_code_card_body:
    'We invite our esteemed guests to grace our celebration adorned in traditional attire, in all its richness and cultural elegance.\n\nEach garment should reflect dignity, heritage, and respect honoring the sacred beauty of a traditional union.\n\nThere is no restriction on colour. Instead, we encourage a radiant display of hues that mirrors the couple\'s love—bright, magical, and timeless—a living tapestry of culture, joy, and celebration.\n\nKindly note that casual wear, denim, and all non-traditional attire are respectfully prohibited. This day is reserved for tradition in its purest and most graceful form.\n\nLet your attire tell a story—of ancestry, pride, and the splendour of love celebrated the traditional way.',
};

function pick(settings, key) {
  const raw = settings?.[key];
  const fallback = INFO_CARDS_DEFAULTS[key] ?? '';
  const value = raw === undefined || raw === null || String(raw).trim() === ''
    ? fallback
    : String(raw);
  return value.trim();
}

export function infoCardsFromSettings(settings) {
  return {
    gifting: {
      title: pick(settings, 'gifting_card_title'),
      body: pick(settings, 'gifting_card_body'),
      contact: pick(settings, 'gifting_card_contact'),
    },
    dressCode: {
      title: pick(settings, 'dress_code_card_title'),
      body: pick(settings, 'dress_code_card_body'),
    },
  };
}

/** Split stored body into paragraphs (blank line = new paragraph). */
export function bodyParagraphs(body) {
  return String(body || '')
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);
}
